import httpx from '../../utils/httpX'

// 获取品牌库列表数据
export const fetchBrandLibList = () => {
  return httpx.get('/apigateway/pcConsole/public/brandLib/list', {})
}
